import { NameErrorValues, NameInputValues } from './NameInput.types';

export const validateField = (
  prev: NameErrorValues,
  value: string,
  field: keyof NameInputValues,
  userNameValues: NameInputValues,
): NameErrorValues => {
  const defaultValue = userNameValues[field]?.toLowerCase() ?? '';
  const inputValue = value.toLowerCase();

  // If default user value is empty, field is optional
  const isOptional = defaultValue === '';

  // If optional and user didn't type anything, remove error entirely
  if (isOptional && inputValue === '') {
    const { [field]: _, ...rest } = prev;
    return rest;
  }

  const isValid = defaultValue === inputValue;

  return {
    ...prev,
    [field]: isValid ? null : `${field}Error`,
  };
};

export const updateNameFieldValue = (
  prev: NameInputValues | null,
  field: keyof NameInputValues,
  value: string,
): NameInputValues => {
  return {
    ...(prev ?? {}),
    [field]: value,
  };
};
